import { render } from "./App.vue?vue&type=template&id=a8787cc8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a8787cc8&lang=scss"
import "./App.vue?vue&type=style&index=1&id=a8787cc8&lang=scss"
import "./App.vue?vue&type=style&index=2&id=a8787cc8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8787cc8"]])

export default __exports__